// extracted by mini-css-extract-plugin
module.exports = {"textLink":"styles_textLink__6PWWm"};